import { FC, useEffect, useState } from "react";
import { ModalProposta, Projeto } from "../../types";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { LoginStore } from "src/framework/store/LoginStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { notifierStore } from "src/framework/store/NotifierStore";

export enum TiposVisualizacaoProposta {
    SIMPLIFICADA = "simplificada",
    DETALHADA = "detalhada"
}

interface ModalBaixarPropostasParams {
    open: boolean;
    setOpenModal: Function;
    tipo?: TiposVisualizacaoProposta;
    projeto?: Projeto;
}

const ModalBaixarProposta: FC<ModalBaixarPropostasParams> = (ModalBaixarPropostasParams) => {
    const [dataProposta, setDataProposta] = useState<ModalProposta | null>(null);
    const [openProposta, setOpenProposta] = useState<boolean>(false);
    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    
    const handleClose = () => {
        ModalBaixarPropostasParams.setOpenModal(false);
    };
    
    useEffect(() => {
        const projetoAtual = ModalBaixarPropostasParams.projeto;
        if (projetoAtual !== undefined) {
            processaChamadaPdf(projetoAtual, permissoes)
        }
    }, [ModalBaixarPropostasParams.open, permissoes]);


    useEffect(() => {
        if (openProposta && dataProposta) {
            const link = document.createElement("a");
            link.href = dataProposta?.url;
            link.setAttribute("download", `Proposta_${dataProposta?.codigo_venda}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            handleClose();
        }
    }, [openProposta, dataProposta, handleClose]);

    async function processaChamadaPdf(projetoAtual: Projeto, permissoesList: typeof permissoes) {
        let condition = 0;
        if (ModalBaixarPropostasParams.tipo !== undefined && permissoesList.length) {
            const aviso = `Não foi possível carregar a proposta ${ModalBaixarPropostasParams.tipo} do projeto.`
            if (PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_DISCRIMINAR_VALORES, permissoesList) && projetoAtual?.tipo !== "vertical") {
                confirmationDialog.setup({
                    title: "",
                    content: 'Deseja discriminar valores unitários na proposta?',
                    onClose: () => {
                        condition +=1
                        confirmationDialog.close();
                        if (condition < 2) {
                            const response = callPdf(projetoAtual, "false", ModalBaixarPropostasParams.tipo+"")
                            showPdf(response, projetoAtual, ModalBaixarPropostasParams.tipo+"", aviso)
                        }
                    },
                    onConfirmation: async () => {
                        condition +=1
                        const response = callPdf(projetoAtual, "true", ModalBaixarPropostasParams.tipo+"")
                        showPdf(response, projetoAtual, ModalBaixarPropostasParams.tipo+"", aviso);
                    }
                })
                confirmationDialog.open()
            } else {
                const response = callPdf(projetoAtual, "", ModalBaixarPropostasParams.tipo+"")
                showPdf(response, projetoAtual, ModalBaixarPropostasParams.tipo+"", aviso)
            }
        }
    }

    async function callPdf(projeto: Projeto, svalores?: string, tipo?: string) : Promise<IDataResponse<any>> {
        setDataProposta(null);
        let url = ''
        if(svalores && tipo) {
            url = `/projetos/propostas/pdf?codigo_venda=${projeto.codigo_venda}&svalores=${svalores}&tipo=${tipo}&forca_atualizacao_proposta=true`
        } 
        if (!svalores && tipo) {
            url = `/projetos/propostas/pdf?codigo_venda=${projeto.codigo_venda}&tipo=${tipo}&forca_atualizacao_proposta=true`
        }
        if (projeto?.migrado || projeto?.origem === 'V1') {
            const propostaV2 = projeto?.uploads?.every(i => i?.origem === 'V2');
            if (propostaV2) {
                url = `/projetos/propostas/pdf?codigo_venda=${projeto.codigo_venda}&svalores=${svalores}&tipo=${tipo}&forca_atualizacao_proposta=true`
            } else {
                url = `/projetos/propostas/pdf?codigo_venda=${projeto.codigo_venda}&tipo=${tipo}`
            }
        }
        const request: IDataRequest = {
            url: url,
        }
        return await api.getFile(request)
    } 

    async function showPdf(response: Promise<IDataResponse<any>>, projeto: Projeto, tipo: string, aviso: string) {
        response.then(r => {
            const blob = new Blob([new Uint8Array(r.data)],{type:'application/pdf'})
            if (r.statusCode === STATUS_CODE.OK && blob) {
                setDataProposta({
                    codigo_venda: projeto?.codigo_venda ||  "",
                    projetoId: projeto?.id || 0,
                    url: URL.createObjectURL(blob),
                    tipo: tipo,
                });
                setOpenProposta(true);
            } else {
                mostraAvisoPropostaSemPdf(aviso);
            }
        }).catch((e) => {
            mostraAvisoPropostaSemPdf(aviso);
        });
    } 

    function mostraAvisoPropostaSemPdf(texto: string) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: [texto],
            timeOut: 3500,
            onClose: () => {
                notifierStore.setOpen(false);
                handleClose();
            }
        });
        notifierStore.setOpen(true); 
    }

    return (<></>)
}

export { ModalBaixarProposta }
